export default __webpack_public_path__ + "static/media/Yurt4.da479504.jpg";